<template>
  <v-container>
    <v-card class="bg-card rounded-xl py-5 mt-5">
      <h4 class="text-center text-h4 mb-5">Historial de Errores</h4>

      <div
        class="
          mx-5 mx-md-4
          px-md-4
          d-flex
          flex-column flex-md-row
          align-center align-md-baseline
        "
      >
        <div style="width: 250px">
          <v-text-field
            outlined
            dense
            solo
            placeholder="Buscar"
            class="rounded-lg"
            prepend-inner-icon="fa-search"
            v-model="search"
          ></v-text-field>
        </div>

        <v-spacer />
      </div>

      <div class="mx-5 mx-md-4 px-md-4">
        <v-data-table
          :headers="headers"
          :items="errorLogs"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          hide-default-footer
          class="elevation-1 rounded-lg"
          @page-count="pageCount = $event"
        >
          <!-- <template v-slot:item.firstName="{ item }">
            {{ item.firstName }} {{ item.lastName }}
          </template> -->
          <template v-slot:item.createdAt="{ item }">
            {{ formatDate(item.createdAt) }} {{ formatHours(item.createdAt) }}
          </template>
        </v-data-table>
        <div
          class="pt-2 d-flex flex-column flex-md-row align-center justify-end"
        >
          <span class="font-quicksand">Filas por páginas: </span>
          <span style="width: 50px" class="mx-md-2">
            <v-select
              v-model="itemsPerPage"
              :items="itemsPerPages"
              class="font-quicksand"
            ></v-select>
          </span>
          <span class="font-quicksand"
            >1-{{ itemsPerPage }} de {{ errorLogs.totalItems }}
          </span>
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="pageVisible"
            color="red"
            class="font-work-sans"
          ></v-pagination>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { format } from 'date-fns'
import Repository from '@/repositories/RepositoryFactory'

const ErrorLogRepository = Repository.get('errorLogs')

export default {
  name: 'ErrorLogs',
  data: () => ({
    search: '',
    errorLogs: [],
    itemsPerPage: 7,
    pageVisible: 5,
    page: 1,
    pageCount: 0,
    headers: [
      {
        text: 'Método',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'description.method',
      },
      {
        text: 'Ruta',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'description.route',
      },
      {
        text: 'Error',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'description.error',
      },
      {
        text: 'Fecha',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'createdAt',
      },
    ],
    itemsPerPages: [7, 10, 20, 30, 50, 100],
  }),
  computed: {
    roleUser: function () {
      return this.$store.state.auth.user?.roleId || ''
    },
  },
  mounted: async function () {
    await this.loadData()
  },
  methods: {
    loadData: async function () {
      this.$eventBus.emit('loading-page')
      try {
        const res = await ErrorLogRepository.get()
        this.errorLogs = res.data.data
      } catch (error) {
        if (error.response?.status === 401) {
          localStorage.removeItem('user')
          location.reload()
        }

        const response = error.response ? error.response.data.message : error

        console.log(response)
      }
    },
    formatDate: (value) => {
      const date = value ? new Date(value) : new Date()
      return format(date, 'dd/MM/yyyy')
    },
    formatHours: (value) => {
      const date = value ? new Date(value) : new Date()
      return date.toLocaleString('es-VE', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      })
    },
  },
}
</script>
